// 参考 d3-ticks nice 的实现
// https://github.com/d3/d3-scale
import { tickIncrement } from './ticks';
export var d3LinearNice = function d3LinearNice(min, max) {
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var d = [min, max];
  var i0 = 0;
  var i1 = d.length - 1;
  var start = d[i0];
  var stop = d[i1];
  var step;

  if (stop < start) {
    var _ref = [stop, start];
    start = _ref[0];
    stop = _ref[1];
    var _ref2 = [i1, i0];
    i0 = _ref2[0];
    i1 = _ref2[1];
  }

  step = tickIncrement(start, stop, count);

  if (step > 0) {
    start = Math.floor(start / step) * step;
    stop = Math.ceil(stop / step) * step;
    step = tickIncrement(start, stop, count);
  } else if (step < 0) {
    start = Math.ceil(start * step) / step;
    stop = Math.floor(stop * step) / step;
    step = tickIncrement(start, stop, count);
  }

  if (step > 0) {
    d[i0] = Math.floor(start / step) * step;
    d[i1] = Math.ceil(stop / step) * step;
  } else if (step < 0) {
    d[i0] = Math.ceil(start * step) / step;
    d[i1] = Math.floor(stop * step) / step;
  }

  return d;
};